import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  margin: 10px 0;

  .container {
    box-sizing: border-box;
    height: 50px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    background: ${({ theme }) => theme.colors.surface.surface};
  }

  .containerButton {
    display: flex;
    align-items: center;
    padding: 0 15px;
    margin-left: 9px;
    cursor: pointer;

    p {
      display: none;
      font-size: 10px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};

      &.selected {
        color: ${({ theme }) => theme.colors.primary.primary};
      }
    }
  }

  .containerUsername {
    width: 438px;
    padding-left: 28px;
  }

  .username {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    padding-left: 26px;
  }

  @media (max-width: 1024px) {
    .containerButton {
      display: block;
      align-items: center;
      text-align: -webkit-center;
      padding-top: 5px;

      i {
        font-size: 15px !important;
      }
      
      p {
        display: block;
      }
    }
  }
`;
